import { useOutletContext } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";

export default function AdminOverview() {
  const { stats } = useOutletContext() || {};

  if (!stats) {
    return <p className="text-sm text-slate-500">Loading stats…</p>;
  }

  const s = stats;
  const inr = (n) => `₹${n.toLocaleString("en-IN")}`;

  return (
    <div className="space-y-6" data-testid="admin-overview">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Overview</h1>
        <p className="text-sm text-slate-500 mt-1">Live snapshot across all exporters.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Stat label="Total users" value={s.users.total} testid="stat-total-users" />
        <Stat label="Onboarded" value={s.users.onboarded} testid="stat-onboarded" />
        <Stat label="Transactions" value={s.transactions.count} testid="stat-txn-count" />
        <Stat label="Volume (INR)" value={inr(Math.round(s.transactions.total_inr))} testid="stat-inr-volume" mono />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card>
          <CardContent className="p-6">
            <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-3">By KYB status</p>
            <div className="space-y-2">
              {Object.entries(s.users.by_kyb_status).map(([k, v]) => (
                <div key={k} className="flex justify-between text-sm">
                  <span className="text-slate-600">{k.replaceAll("_", " ")}</span>
                  <span className="font-semibold sf-mono" data-testid={`stat-kyb-${k}`}>{v}</span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="p-6">
            <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-3">By business type</p>
            <div className="space-y-2">
              {Object.entries(s.users.by_business_type).map(([k, v]) => (
                <div key={k} className="flex justify-between text-sm">
                  <span className="text-slate-600">{k.replaceAll("_", " ")}</span>
                  <span className="font-semibold sf-mono" data-testid={`stat-bt-${k}`}>{v}</span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

function Stat({ label, value, mono, testid }) {
  return (
    <Card>
      <CardContent className="p-5">
        <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{label}</p>
        <p className={`text-2xl font-bold text-slate-900 mt-1 ${mono ? "sf-mono" : ""}`} data-testid={testid}>
          {value}
        </p>
      </CardContent>
    </Card>
  );
}
